/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Empty_Description_Admin_OnlyInputs */



/**
* | output |
* | --- |
* | "Agents in your organization are created by an administrator." |
*
* @param {Agent_Builder_Empty_Description_Admin_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_empty_description_admin_only = /** @type {((inputs?: Agent_Builder_Empty_Description_Admin_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Empty_Description_Admin_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Agenten werden in Ihrer Organisation von einem Administrator erstellt.")
	return /** @type {LocalizedString} */ ("Agents in your organization are created by an administrator.")
});